var CardTextList = function () {

	this.init = function () {
		$('[data-component="card-text-list"] .row').slick({
			dots: false,
			slidesToShow: 3,
			infinite: false,
			arrows: false,
			adaptiveHeight: true,
			responsive: [{
					breakpoint: 992,
					settings: {
						slidesToShow: 2,
						dots: true
					}
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 1,
						dots: true
					}
				}
			]
		});
	}

	return this.init();
}
